/**
 * Строки CRM-хрома канвы ЖК (WYSIWYG-формы проекта): якорная полоса, панель,
 * список ошибок. Подписи самого сайта сюда не кладутся — их канва берёт из
 * сгенерированного словаря сайта (constants/siteDictionary.gen.ts).
 *
 * Видимые строки — из текстовых слоёв макета; '@' и '|' экранировать как
 * {'@'} и {'|'}.
 */

const ruCanvas = {
  apartments: {
    fromUnits: 'Формируется из юнитов и витрины',
    openUnits: 'Открыть вкладку «Юниты» →',
    objectTypes: 'Типы объектов:',
    imagesHint: 'Правится на витрине — вкладка «Юниты»',
    emptyTitle: 'Появится после добавления юнитов',
    emptyHint: 'Сохраните проект — откроется вкладка «Юниты»',
    goUnits: 'Перейти к юнитам',
  },
  about: {
    upload: 'Загрузить',
    uploadHint: 'В выбранную подгруппу; при «Все» — в «Общие»',
    groups: {
      all: 'Все',
      IMAGE_TYPE_COMMON: 'Общие',
      IMAGE_TYPE_EXTERIOR: 'Экстерьер',
      IMAGE_TYPE_INTERIOR: 'Интерьер',
      IMAGE_TYPE_FLOOR_PLAN: 'Поэтажные планы',
      IMAGE_TYPE_LAYOUT: 'Планировки',
    },
    pills: {
      IMAGE_TYPE_COMMON: 'О',
      IMAGE_TYPE_EXTERIOR: 'Э',
      IMAGE_TYPE_INTERIOR: 'И',
      IMAGE_TYPE_FLOOR_PLAN: 'П',
      IMAGE_TYPE_LAYOUT: 'Пл',
    },
    newCategory: 'новая категория',
    plansCrop: 'на сайте кадр 4:3 — планы могут обрезаться',
    counter: '{n} / {total}',
    emptyGroup: 'В «{group}» пока пусто — перетащите сюда',
    emptyTitle: 'Фото проекта',
    emptyHint: 'Экстерьер, интерьер, поэтажные планы, планировки — по категориям · 3:2, ≥1600×1067',
    addRatio: '3:2',
    flagsCommonOnly: 'флаги только у «Общих»',
    crossForbidden: 'Перенос между категориями запрещён — удалите и загрузите заново в нужную',
    hidden: 'На сайте секция скрыта, пока нет ни описания, ни фото',
    safeMobile: 'моб. 300px',
  },
  urls: {
    button: 'По ссылкам',
    label: 'Ссылки, по одной в строке',
    addToList: 'В список',
    ready: 'Готовы к загрузке: {n}',
    uploadAll: 'Загрузить все',
    uploaded: 'Загружено картинок: {n}',
    failed: 'Не удалось скачать ссылок: {n}',
    reasons: {
      forbidden: 'нет доступа (403)',
      notFound: 'файл не найден (404)',
      tooLarge: 'файл слишком большой',
      emptyFolder: 'в папке нет картинок',
      driveDisabled: 'Google Drive не подключён',
      other: 'не удалось скачать',
    },
  },
  description: {
    pill: 'Описание · {locale}',
    chars: '{n} зн.',
    minimum: '{n} зн. · минимум {min}',
    autoTranslate: '{n} зн. · пусто — переведётся при сохранении',
    placeholder:
      "Опишите проект для покупателя: что это, где, концепция, для кого. 2–4 абзаца, 600–1500 знаков. Первым абзацем — суть: «{'{'}Название{'}'} — это … в {'{'}Город{'}'}». Минимум 10 символов на любом языке, остальные переведутся автоматически",
    ghost: 'Оставьте пустым — описание переведётся при сохранении. Либо вставьте свой перевод',
    showRu: 'Показать RU рядом',
    hideRu: 'Скрыть RU',
    ruReadonly: 'RU · только чтение',
  },
  location: {
    city: 'Город',
    cityPlaceholder: 'Выберите город',
    cityHint: 'Город идёт в крошки и каталог',
    addressPlaceholder: 'Улица, район, город — минимум 10 символов',
    counter: '{n}/{min}',
    pick: 'Указать точку',
    pickHint: 'Кликните по карте · Esc — отмена',
    mapFailed: 'Карта не загрузилась',
    addressFromPoint: 'Адрес обновлён по точке: «{address}»',
    restoreAddress: 'Вернуть прежний',
  },
  panel: {
    fromUnits: 'из юнитов →',
    noChanges: 'Без изменений',
    saveShortcut: '{keys} — сохранить',
    language: 'Язык контента',
    languageHint:
      'Переключает описание проекта, SEO и описание застройщика. Название, акции и подписи — общие (сайт переведёт сам)',
    localeDots:
      '● — описание и SEO заполнены · ◐ — описание без SEO · ○ — пусто, переведётся при сохранении',
    preview: 'Как на сайте',
    previewHint:
      'Прячет подсказки, пунктиры, пустые слоты и CRM-счётчики — чистый рендер для сверки',
    featured: 'В подборке на главной',
    visibilityHint: 'Выключено — черновик, виден только в CRM',
    featuredHint: 'Карточка на главной; картинка — с ★ «Главная»',
    agentsHint: 'Не зависит от публикации на сайте',
    seoInfo:
      'Эти тексты уходят только в HTML для ботов (SSR). Люди во вкладке браузера видят «{title}»',
    seoTitlePlaceholder: "Купить квартиру в {'{'}Название{'}'} — цены от застройщика",
    seoDescriptionPlaceholder: "{'{'}Название{'}'} в {'{'}Город{'}'}: что за проект, цены, сдача",
    seoWillTranslate:
      'переведётся при сохранении; если перевод не удастся — боты увидят исходный текст',
    seoBotsSee: 'боты увидят: {text}',
    seoOverLimit: 'обрежется до {max}',
    featuresHint: '«Доступен иностранцам» и «Розовая книга» — в секции «Иностранцам» на странице',
    foreigner: 'Доступен иностранцам (внутренняя проверка)',
    agentCommission: 'Комиссия агента, %',
    notPublished: 'не публикуется',
    yes: 'Да',
    no: 'Нет',
    commission: 'Комиссия VINPROP',
    commissionPercent: 'Ставка, %',
    commissionSavedAt: 'Сохранено {time}',
    commissionUnsaved: 'Не сохранено',
    commissionEmptyHint: 'Пусто — ставка не задана (не 0)',
    commissionBaseHint: 'База вознаграждений сделки: цена без НДС × ставка',
    commissionNoRight: 'Меняет только роль с правом управления комиссией',
    commissionNotSet: 'не задана',
    commissionLater: 'Комиссия VINPROP — после создания',
    commissionClear: 'Ставка будет снята — у новых сделок базы вознаграждения не будет.',
    salesStartNotSet: 'Старт продаж не задан',
    salesStartEdit: 'Изменить → Юниты',
    salesStartHint: 'Флаг живёт на вкладке Юниты и снимается только вручную',
    salesStartLater: 'Старт продаж — после создания',
  },
  save: {
    uploading:
      'Идёт загрузка {n} файла — дождитесь окончания | Идёт загрузка {n} файлов — дождитесь окончания | Идёт загрузка {n} файлов — дождитесь окончания',
    invalid:
      'Проверьте поля, выделенные красным · {n} ошибка | Проверьте поля, выделенные красным · {n} ошибки | Проверьте поля, выделенные красным · {n} ошибок',
    errorsTitle: 'Не сохранено: {n} ошибка | Не сохранено: {n} ошибки | Не сохранено: {n} ошибок',
    allFixed: 'Ошибок нет — нажмите «Сохранить»',
    toFirst: 'К первой ошибке',
    previewBlocked: 'Сначала исправьте ошибки',
  },
  promos: {
    add: 'Добавить акцию',
    example: 'Например: «Рассрочка 0% на 24 месяца»',
    counter: '{n} симв. · минимум {min}',
    removed: 'Акция удалена',
    remove: 'Удалить акцию',
    hint: 'Акции не переводятся: сайт показывает их как есть на всех языках. Пустая акция при сохранении просто пропадёт',
  },
  tiles: {
    photos: '{n} фото',
    upload: 'Загрузить',
    slide: 'Слайд {n}',
    add: 'Добавить',
    addHint: '≥800×1000 · 4:5',
    finishingEmpty: 'Фото отделки',
    constructionEmpty: 'Фото со стройки',
    emptyHint: '4:5, от 800×1000',
    pickFiles: 'Выбрать файлы',
    replace: 'Заменить',
    remove: 'Удалить',
    toStart: 'В начало',
    toEnd: 'В конец',
    menu: 'Действия с фото',
    earliestFirst: 'Первое фото — самое раннее',
    firstOldest: '№1 · старые → новые',
    overlaySafe: 'Нижние 48 px первой плитки слайда закрывает подпись «Варианты отделки от …»',
  },
  masterPlan: {
    empty: 'Загрузите генплан',
    hint: 'Одна картинка, PNG/JPG, ширина от 1600',
    pick: 'Выбрать файл',
    dropReplace: 'Отпустите — заменим генплан',
    removed: 'Генплан удалён',
  },
  toggles: {
    counter: '{n} из {total}',
    selectAll: 'Выбрать все',
    clearAll: 'Снять все',
    foreignersLink: 'Также добавляет фразу в секцию «Иностранцам»',
  },
  foreigners: {
    permitOff: 'Разрешение на продажу иностранцам — не отмечено',
    availableHint: 'Не путать со служебным «Доступен иностранцам» в панели — на сайт не идёт',
    autoText: 'Текст собирается автоматически из признаков',
    textLocale: 'Текст: {locale}',
  },
  header: {
    namePlaceholder: 'Название проекта',
    highlights: 'Преимущества',
    crmLabel: 'в CRM: {label}',
    rankTitle: 'Класс проекта',
    rankEmpty: 'Не указано',
    typeTitle: 'Тип проекта',
    typeEmpty: 'Не задано',
    handoverTitle: 'Срок сдачи',
  },
  developer: {
    empty: 'Выберите застройщика',
    title: 'Застройщик',
    projects: '{n} проект | {n} проекта | {n} проектов',
    loadError: 'Не удалось загрузить застройщика',
    textLocale: 'Текст: {locale}',
    separately: 'Сохраняется отдельно',
    edit: 'Изменить застройщика',
    change: 'Сменить',
    nameLinkHint: 'Ссылка на страницу застройщика, в CRM отключена',
    notSelected: 'Застройщик не выбран',
    logoHint: 'Логотип меняется в карточке застройщика · PNG 1:1 ≥320×320',
  },
  other: {
    auto: 'авто',
    none: 'У {developer} пока нет других ЖК',
    later: 'Подтянутся автоматически после сохранения',
    failed: 'Не удалось загрузить другие ЖК',
  },
  ribbon: {
    label: 'Кадры шапки',
    keys: '←/→ — переход, Shift+стрелка — перестановка, Delete — удалить, F — «Главная», O — og:image, ⌘Z — вернуть удалённое',
    count: 'Шапка · {n} фото',
    cardsFirst: '1 · карточки каталога',
    addHint: '≥1920×900',
    selected: 'Выбрано {n}',
    makeFirst: 'Сделать первой',
    remove: 'Удалить',
    removeFrame: 'Удалить кадр',
    drag: 'Перетащить',
    mainPage: 'Главная сайта',
    mainPageHint: 'В карусель главной кадр попадает, только если проект «В подборке на главной»',
    og: 'og:image — картинка для соцсетей',
    ogElsewhere: 'og:image сейчас — из «{section}»',
  },
  crumbs: {
    cityPlaceholder: 'Город',
    namePlaceholder: 'Название проекта',
    url: 'URL: {url}',
    urlLater: 'URL появится после сохранения',
    urlWillChange: 'Адрес пересчитается после сохранения',
    cityHint: 'Город правится в «Расположении»',
  },
  hero: {
    dropTitle: 'Перетащите фото шапки или нажмите «Загрузить»',
    dropHint: 'JPG/PNG, от 1920×900',
    upload: 'Загрузить',
    dropRelease: 'Отпустите — добавится в шапку',
    fromUnits: 'из юнитов',
    fromUnitsLater: 'появится из юнитов',
    fromUnitsHint: 'Диапазон считается по витрине — правится на вкладке «Юниты»',
    siteButtonHint: 'Кнопка сайта, в CRM неактивна',
    safeZone: 'Безопасная зона',
    viewports: { '1440': '1440', '1920': '1920', mobile: 'моб.' },
    replace: 'Заменить этот кадр',
    remove: 'Удалить',
    prev: 'Предыдущий кадр',
    next: 'Следующий кадр',
    frame: 'Кадр {n}',
    zones: {
      price: 'Здесь будет цена',
      promo: 'Здесь бейдж акций',
      strip: 'Здесь полоса застройщика',
      wide: 'Обрежется на 1920',
      mobile: 'Обрежется на мобиле',
    },
  },
  images: {
    progress: '{done} из {total}',
    small: '{actual} — меньше рекомендуемых {recommended}',
    portrait: 'Фото обрежется до 4:5',
    retry: 'Повторить',
    dismiss: 'Убрать',
    removed: 'Удалено',
    restore: 'Вернуть',
    singleTaken: 'Генплан — одна картинка: взята первая',
    restToCommon: 'Добавить остальные в «Общие»',
    noPreview: 'og:image не задан — соцсети возьмут первый кадр',
    errors: {
      format: 'Формат не подходит: нужен JPG, PNG, GIF или WebP',
      size: 'Файл больше 32 МБ',
      upload: 'Файл не загрузился',
    },
  },
  tray: {
    hint: 'Без категории картинки не попадут на сайт',
    assignFailed: 'Не удалось разложить картинки: {message}',
    removeFailed: 'Не удалось удалить картинки передержки: {message}',
    cleanupFailed: 'Не удалось удалить картинки передержки: {message} — попробуйте ещё раз',
    deleteAllTitle:
      'Удалить {count} картинку из облака? | Удалить {count} картинки из облака? | Удалить {count} картинок из облака?',
    deleteAllDescription: 'Это необратимо: файлы передержки будут стёрты.',
    deleteAllAction: 'Удалить {count}',
    publishTitle: 'Опубликовать проект',
    publishWarning:
      '{count} картинка передержки будет удалена из облака | {count} картинки передержки будут удалены из облака | {count} картинок передержки будут удалены из облака',
    publishAction: 'Опубликовать и удалить {count}',
  },
  head: {
    published: 'Опубликован',
    filled: 'Заполнено {n} из {total}',
    changes: 'Изменений: {n}',
    errors: '{n} ошибка | {n} ошибки | {n} ошибок',
    create: 'Создать проект',
    saving: 'Сохраняем…',
    saveAndPublish: 'Сохранить и опубликовать',
    saveAndUnpublish: 'Сохранить и снять с сайта',
  },
  anchors: {
    label: 'Секции страницы',
    emptyHint: 'Пусто — на сайте секция скрыта',
  },
  leave: {
    title: 'Изменения не сохранены',
    stay: 'Остаться',
    leave: 'Уйти без сохранения',
    changes:
      'В проекте {n} несохранённое изменение | В проекте {n} несохранённых изменения | В проекте {n} несохранённых изменений',
    changesShort: 'В проекте {n} изменение | В проекте {n} изменения | В проекте {n} изменений',
    commission: 'ставка комиссии VINPROP не сохранена',
    commissionOnly: 'Ставка комиссии VINPROP не сохранена',
    uploads: 'Идёт загрузка {n} файла | Идёт загрузка {n} файлов | Идёт загрузка {n} файлов',
    uploadsTail: 'они не попадут в проект',
    question: 'Уйти без сохранения?',
  },
  noPermission: 'Недостаточно прав для редактирования проекта',
  load: {
    errorTitle: 'Не удалось загрузить проект',
    retry: 'Повторить',
    toList: 'К списку проектов',
  },
  sections: {
    hero: 'Шапка',
    header: 'Заголовок',
    amenities: 'Инфра',
    masterPlan: 'Генплан',
    apartments: 'Квартиры',
    promos: 'Акции',
    about: 'О проекте',
    location: 'Расположение',
    finishing: 'Отделка',
    developer: 'Застройщик',
    construction: 'Стройка',
    documents: 'Документы',
    foreigners: 'Иностранцам',
    other: 'Ещё ЖК',
  },
  panelGroups: {
    publication: 'Публикация',
    seo: 'SEO',
    noPlace: 'Без места на сайте',
    service: 'Служебная',
  },
  errors: {
    promoTooShort: 'Акция №{n} — не короче {min} символов',
    agentCommissionRange: 'Комиссия агента — число от 0 до 100',
    wrongLanguage: {
      projectDescription: 'Описание {locale} похоже на {language}: {words}',
      seoTitle: 'SEO Title {locale} похож на {language}: {words}',
      seoDescription: 'SEO Description {locale} похоже на {language}: {words}',
    },
  },
}

const enCanvas = {
  apartments: {
    fromUnits: 'Built from units and the showcase',
    openUnits: 'Open the «Units» tab →',
    objectTypes: 'Object types:',
    imagesHint: 'Edited in the showcase — «Units» tab',
    emptyTitle: 'Will appear once units are added',
    emptyHint: 'Save the project — the «Units» tab will open',
    goUnits: 'Go to units',
  },
  about: {
    upload: 'Upload',
    uploadHint: 'Into the selected subgroup; with «All» — into «Common»',
    groups: {
      all: 'All',
      IMAGE_TYPE_COMMON: 'Common',
      IMAGE_TYPE_EXTERIOR: 'Exterior',
      IMAGE_TYPE_INTERIOR: 'Interior',
      IMAGE_TYPE_FLOOR_PLAN: 'Floor plans',
      IMAGE_TYPE_LAYOUT: 'Layouts',
    },
    pills: {
      IMAGE_TYPE_COMMON: 'C',
      IMAGE_TYPE_EXTERIOR: 'E',
      IMAGE_TYPE_INTERIOR: 'I',
      IMAGE_TYPE_FLOOR_PLAN: 'F',
      IMAGE_TYPE_LAYOUT: 'L',
    },
    newCategory: 'new category',
    plansCrop: 'the website frame is 4:3 — plans may be cropped',
    counter: '{n} / {total}',
    emptyGroup: '«{group}» is empty — drop files here',
    emptyTitle: 'Project photos',
    emptyHint: 'Exterior, interior, floor plans, layouts — by category · 3:2, ≥1600×1067',
    addRatio: '3:2',
    flagsCommonOnly: 'flags are for «Common» only',
    crossForbidden:
      'Moving between categories is not allowed — delete and upload again to the right one',
    hidden: 'The website hides this section until there is a description or a photo',
    safeMobile: 'mob. 300px',
  },
  urls: {
    button: 'From links',
    label: 'Links, one per line',
    addToList: 'Add to list',
    ready: 'Ready to upload: {n}',
    uploadAll: 'Upload all',
    uploaded: 'Images uploaded: {n}',
    failed: 'Links not downloaded: {n}',
    reasons: {
      forbidden: 'access denied (403)',
      notFound: 'file not found (404)',
      tooLarge: 'file is too large',
      emptyFolder: 'no images in the folder',
      driveDisabled: 'Google Drive is not connected',
      other: 'could not download',
    },
  },
  description: {
    pill: 'Description · {locale}',
    chars: '{n} chars',
    minimum: '{n} chars · at least {min}',
    autoTranslate: '{n} chars · empty — will be translated on save',
    placeholder:
      "Describe the project for a buyer: what it is, where, the concept, who it is for. 2–4 paragraphs, 600–1500 characters. Start with the essence: «{'{'}Name{'}'} is … in {'{'}City{'}'}». At least 10 characters in any language; the others are translated automatically",
    ghost:
      'Leave empty — the description will be translated on save. Or paste your own translation',
    showRu: 'Show RU alongside',
    hideRu: 'Hide RU',
    ruReadonly: 'RU · read only',
  },
  location: {
    city: 'City',
    cityPlaceholder: 'Select a city',
    cityHint: 'The city goes to the breadcrumbs and the catalog',
    addressPlaceholder: 'Street, district, city — at least 10 characters',
    counter: '{n}/{min}',
    pick: 'Drop a pin',
    pickHint: 'Click the map · Esc to cancel',
    mapFailed: 'The map did not load',
    addressFromPoint: 'Address updated from the pin: «{address}»',
    restoreAddress: 'Restore previous',
  },
  panel: {
    fromUnits: 'from units →',
    noChanges: 'No changes',
    saveShortcut: '{keys} — save',
    language: 'Content language',
    languageHint:
      'Switches the project description, SEO and the developer description. Name, offers and captions are shared (the website translates them)',
    localeDots:
      '● — description and SEO filled · ◐ — description without SEO · ○ — empty, will be translated on save',
    preview: 'As on the website',
    previewHint:
      'Hides hints, dashed outlines, empty slots and CRM counters — a clean render to compare',
    featured: 'Featured on the home page',
    visibilityHint: 'Off — a draft, visible only in CRM',
    featuredHint: 'A card on the home page; the image is the one marked ★ «Home»',
    agentsHint: 'Does not depend on publishing on the website',
    seoInfo:
      'These texts go only to the HTML for bots (SSR). People see «{title}» in the browser tab',
    seoTitlePlaceholder: "Buy an apartment in {'{'}Name{'}'} — developer prices",
    seoDescriptionPlaceholder:
      "{'{'}Name{'}'} in {'{'}City{'}'}: what the project is, prices, handover",
    seoWillTranslate:
      'will be translated on save; if translation fails, bots will see the source text',
    seoBotsSee: 'bots will see: {text}',
    seoOverLimit: 'will be cut to {max}',
    featuresHint:
      '«Available to foreigners» and «Pink book» are in the «Foreigners» section of the page',
    foreigner: 'Available to foreigners (internal check)',
    agentCommission: 'Agent commission, %',
    notPublished: 'not published',
    yes: 'Yes',
    no: 'No',
    commission: 'VINPROP commission',
    commissionPercent: 'Rate, %',
    commissionSavedAt: 'Saved {time}',
    commissionUnsaved: 'Not saved',
    commissionEmptyHint: 'Empty — the rate is not set (not 0)',
    commissionBaseHint: 'Deal reward base: price without VAT × rate',
    commissionNoRight: 'Only a role allowed to manage commission can change it',
    commissionNotSet: 'not set',
    commissionLater: 'VINPROP commission — after creation',
    commissionClear: 'The rate will be removed — new deals will have no reward base.',
    salesStartNotSet: 'Sales start not set',
    salesStartEdit: 'Edit → Units',
    salesStartHint: 'The flag lives on the Units tab and is removed only manually',
    salesStartLater: 'Sales start — after creation',
  },
  save: {
    uploading:
      'Uploading {n} file — wait until it finishes | Uploading {n} files — wait until they finish',
    invalid:
      'Check the fields marked in red · {n} error | Check the fields marked in red · {n} errors',
    errorsTitle: 'Not saved: {n} error | Not saved: {n} errors',
    allFixed: 'No errors — press «Save»',
    toFirst: 'To the first error',
    previewBlocked: 'Fix the errors first',
  },
  promos: {
    add: 'Add an offer',
    example: 'For example: «0% installments for 24 months»',
    counter: '{n} chars · at least {min}',
    removed: 'Offer removed',
    remove: 'Delete the offer',
    hint: 'Offers are not translated: the website shows them as is in every language. An empty offer simply disappears on save',
  },
  tiles: {
    photos: '{n} photos',
    upload: 'Upload',
    slide: 'Slide {n}',
    add: 'Add',
    addHint: '≥800×1000 · 4:5',
    finishingEmpty: 'Finishing photos',
    constructionEmpty: 'Construction photos',
    emptyHint: '4:5, from 800×1000',
    pickFiles: 'Choose files',
    replace: 'Replace',
    remove: 'Delete',
    toStart: 'Move to start',
    toEnd: 'Move to end',
    menu: 'Photo actions',
    earliestFirst: 'The first photo is the earliest',
    firstOldest: '#1 · old → new',
    overlaySafe:
      'The bottom 48 px of a slide’s first tile are covered by «Finishing options from …»',
  },
  masterPlan: {
    empty: 'Upload the master plan',
    hint: 'One image, PNG/JPG, at least 1600 wide',
    pick: 'Choose file',
    dropReplace: 'Release to replace the master plan',
    removed: 'Master plan removed',
  },
  toggles: {
    counter: '{n} of {total}',
    selectAll: 'Select all',
    clearAll: 'Clear all',
    foreignersLink: 'Also adds a sentence to the «Foreigners» section',
  },
  foreigners: {
    permitOff: 'Sale permit for foreigners — not checked',
    availableHint:
      'Not the internal «Available to foreigners» in the panel — that one is not published',
    autoText: 'The text is assembled automatically from the features',
    textLocale: 'Text: {locale}',
  },
  header: {
    namePlaceholder: 'Project name',
    highlights: 'Highlights',
    crmLabel: 'in CRM: {label}',
    rankTitle: 'Project class',
    rankEmpty: 'Not specified',
    typeTitle: 'Project type',
    typeEmpty: 'Not set',
    handoverTitle: 'Completion date',
  },
  developer: {
    empty: 'Choose a developer',
    title: 'Developer',
    projects: '{n} project | {n} projects',
    loadError: 'Could not load the developer',
    textLocale: 'Text: {locale}',
    separately: 'Saved separately',
    edit: 'Edit developer',
    change: 'Change',
    nameLinkHint: 'Link to the developer page, disabled in CRM',
    notSelected: 'No developer selected',
    logoHint: 'The logo is changed in the developer card · PNG 1:1 ≥320×320',
  },
  other: {
    auto: 'auto',
    none: '{developer} has no other projects yet',
    later: 'Will be filled in automatically after saving',
    failed: 'Could not load other projects',
  },
  ribbon: {
    label: 'Header frames',
    keys: '←/→ — move, Shift+arrow — reorder, Delete — remove, F — «Homepage», O — og:image, ⌘Z — undo removal',
    count: 'Header · {n} photos',
    cardsFirst: '1 · catalog cards',
    addHint: '≥1920×900',
    selected: 'Selected {n}',
    makeFirst: 'Make first',
    remove: 'Delete',
    removeFrame: 'Delete frame',
    drag: 'Drag',
    mainPage: 'Website homepage',
    mainPageHint:
      'The frame reaches the homepage carousel only if the project is «Featured on the homepage»',
    og: 'og:image — the image for social networks',
    ogElsewhere: 'og:image is currently from «{section}»',
  },
  crumbs: {
    cityPlaceholder: 'City',
    namePlaceholder: 'Project name',
    url: 'URL: {url}',
    urlLater: 'The URL will appear after saving',
    urlWillChange: 'The address will be recalculated after saving',
    cityHint: 'The city is edited in «Location»',
  },
  hero: {
    dropTitle: 'Drop header photos here or click «Upload»',
    dropHint: 'JPG/PNG, from 1920×900',
    upload: 'Upload',
    dropRelease: 'Release to add to the header',
    fromUnits: 'from units',
    fromUnitsLater: 'will come from units',
    fromUnitsHint: 'The range is calculated from the showcase — edit it on the «Units» tab',
    siteButtonHint: 'Website button, inactive in CRM',
    safeZone: 'Safe zone',
    viewports: { '1440': '1440', '1920': '1920', mobile: 'mob.' },
    replace: 'Replace this frame',
    remove: 'Delete',
    prev: 'Previous frame',
    next: 'Next frame',
    frame: 'Frame {n}',
    zones: {
      price: 'Price goes here',
      promo: 'Offers badge goes here',
      strip: 'Developer strip goes here',
      wide: 'Cropped at 1920',
      mobile: 'Cropped on mobile',
    },
  },
  images: {
    progress: '{done} of {total}',
    small: '{actual} — smaller than the recommended {recommended}',
    portrait: 'The photo will be cropped to 4:5',
    retry: 'Retry',
    dismiss: 'Remove',
    removed: 'Removed',
    restore: 'Undo',
    singleTaken: 'Master plan takes one image: the first one was used',
    restToCommon: 'Add the rest to «Common»',
    noPreview: 'og:image is not set — social networks will take the first frame',
    errors: {
      format: 'Unsupported format: use JPG, PNG, GIF or WebP',
      size: 'The file is larger than 32 MB',
      upload: 'The file was not uploaded',
    },
  },
  tray: {
    hint: 'Images without a category will not reach the website',
    assignFailed: 'Could not sort the images: {message}',
    removeFailed: 'Could not delete the import images: {message}',
    cleanupFailed: 'Could not delete the import images: {message} — try again',
    deleteAllTitle: 'Delete {count} image from the cloud? | Delete {count} images from the cloud?',
    deleteAllDescription: 'This cannot be undone: the import files will be erased.',
    deleteAllAction: 'Delete {count}',
    publishTitle: 'Publish the project',
    publishWarning:
      '{count} import image will be deleted from the cloud | {count} import images will be deleted from the cloud',
    publishAction: 'Publish and delete {count}',
  },
  head: {
    published: 'Published',
    filled: 'Filled {n} of {total}',
    changes: 'Changes: {n}',
    errors: '{n} error | {n} errors',
    create: 'Create project',
    saving: 'Saving…',
    saveAndPublish: 'Save and publish',
    saveAndUnpublish: 'Save and unpublish',
  },
  anchors: {
    label: 'Page sections',
    emptyHint: 'Empty — hidden on the website',
  },
  leave: {
    title: 'Unsaved changes',
    stay: 'Stay',
    leave: 'Leave without saving',
    changes: 'The project has {n} unsaved change | The project has {n} unsaved changes',
    changesShort: 'The project has {n} change | The project has {n} changes',
    commission: 'the VINPROP commission rate is not saved',
    commissionOnly: 'The VINPROP commission rate is not saved',
    uploads: 'Uploading {n} file | Uploading {n} files',
    uploadsTail: 'they will not be added to the project',
    question: 'Leave without saving?',
  },
  noPermission: 'You do not have permission to edit this project',
  load: {
    errorTitle: 'Could not load the project',
    retry: 'Retry',
    toList: 'Back to projects',
  },
  sections: {
    hero: 'Hero',
    header: 'Title',
    amenities: 'Amenities',
    masterPlan: 'Master plan',
    apartments: 'Apartments',
    promos: 'Offers',
    about: 'About',
    location: 'Location',
    finishing: 'Finishing',
    developer: 'Developer',
    construction: 'Construction',
    documents: 'Documents',
    foreigners: 'Foreigners',
    other: 'More projects',
  },
  panelGroups: {
    publication: 'Publication',
    seo: 'SEO',
    noPlace: 'Not shown on the website',
    service: 'Internal',
  },
  errors: {
    promoTooShort: 'Offer #{n} must be at least {min} characters',
    agentCommissionRange: 'Agent commission must be between 0 and 100',
    wrongLanguage: {
      projectDescription: 'Description {locale} looks like {language}: {words}',
      seoTitle: 'SEO Title {locale} looks like {language}: {words}',
      seoDescription: 'SEO Description {locale} looks like {language}: {words}',
    },
  },
}

const vnCanvas = {
  apartments: {
    fromUnits: 'Tạo từ căn hộ và danh mục',
    openUnits: 'Mở tab «Căn hộ» →',
    objectTypes: 'Loại bất động sản:',
    imagesHint: 'Sửa trong danh mục — tab «Căn hộ»',
    emptyTitle: 'Sẽ xuất hiện khi thêm căn hộ',
    emptyHint: 'Lưu dự án — tab «Căn hộ» sẽ mở',
    goUnits: 'Đến căn hộ',
  },
  about: {
    upload: 'Tải lên',
    uploadHint: 'Vào nhóm đang chọn; với «Tất cả» — vào «Chung»',
    groups: {
      all: 'Tất cả',
      IMAGE_TYPE_COMMON: 'Chung',
      IMAGE_TYPE_EXTERIOR: 'Ngoại thất',
      IMAGE_TYPE_INTERIOR: 'Nội thất',
      IMAGE_TYPE_FLOOR_PLAN: 'Mặt bằng tầng',
      IMAGE_TYPE_LAYOUT: 'Mặt bằng căn',
    },
    pills: {
      IMAGE_TYPE_COMMON: 'C',
      IMAGE_TYPE_EXTERIOR: 'NgT',
      IMAGE_TYPE_INTERIOR: 'NT',
      IMAGE_TYPE_FLOOR_PLAN: 'T',
      IMAGE_TYPE_LAYOUT: 'MB',
    },
    newCategory: 'nhóm mới',
    plansCrop: 'khung trên website là 4:3 — mặt bằng có thể bị cắt',
    counter: '{n} / {total}',
    emptyGroup: '«{group}» đang trống — kéo tệp vào đây',
    emptyTitle: 'Ảnh dự án',
    emptyHint: 'Ngoại thất, nội thất, mặt bằng tầng, mặt bằng căn — theo nhóm · 3:2, ≥1600×1067',
    addRatio: '3:2',
    flagsCommonOnly: 'chỉ ảnh «Chung» có cờ',
    crossForbidden: 'Không được chuyển giữa các nhóm — hãy xóa và tải lại vào nhóm đúng',
    hidden: 'Website ẩn mục này cho đến khi có mô tả hoặc ảnh',
    safeMobile: 'di động 300px',
  },
  urls: {
    button: 'Từ liên kết',
    label: 'Liên kết, mỗi dòng một',
    addToList: 'Thêm vào danh sách',
    ready: 'Sẵn sàng tải: {n}',
    uploadAll: 'Tải tất cả',
    uploaded: 'Đã tải ảnh: {n}',
    failed: 'Không tải được liên kết: {n}',
    reasons: {
      forbidden: 'không có quyền truy cập (403)',
      notFound: 'không tìm thấy tệp (404)',
      tooLarge: 'tệp quá lớn',
      emptyFolder: 'thư mục không có ảnh',
      driveDisabled: 'Google Drive chưa được kết nối',
      other: 'không tải được',
    },
  },
  description: {
    pill: 'Mô tả · {locale}',
    chars: '{n} ký tự',
    minimum: '{n} ký tự · tối thiểu {min}',
    autoTranslate: '{n} ký tự · trống — sẽ được dịch khi lưu',
    placeholder:
      "Mô tả dự án cho người mua: là gì, ở đâu, ý tưởng, dành cho ai. 2–4 đoạn, 600–1500 ký tự. Đoạn đầu — ý chính: «{'{'}Tên{'}'} là … tại {'{'}Thành phố{'}'}». Tối thiểu 10 ký tự ở bất kỳ ngôn ngữ nào; các ngôn ngữ còn lại được dịch tự động",
    ghost: 'Để trống — mô tả sẽ được dịch khi lưu. Hoặc dán bản dịch của bạn',
    showRu: 'Hiện RU bên cạnh',
    hideRu: 'Ẩn RU',
    ruReadonly: 'RU · chỉ đọc',
  },
  location: {
    city: 'Thành phố',
    cityPlaceholder: 'Chọn thành phố',
    cityHint: 'Thành phố hiển thị ở breadcrumb và danh mục',
    addressPlaceholder: 'Đường, quận, thành phố — tối thiểu 10 ký tự',
    counter: '{n}/{min}',
    pick: 'Đánh dấu vị trí',
    pickHint: 'Nhấp vào bản đồ · Esc để hủy',
    mapFailed: 'Không tải được bản đồ',
    addressFromPoint: 'Địa chỉ đã cập nhật theo vị trí: «{address}»',
    restoreAddress: 'Khôi phục địa chỉ cũ',
  },
  panel: {
    fromUnits: 'từ căn hộ →',
    noChanges: 'Không có thay đổi',
    saveShortcut: '{keys} — lưu',
    language: 'Ngôn ngữ nội dung',
    languageHint:
      'Chuyển mô tả dự án, SEO và mô tả chủ đầu tư. Tên, ưu đãi và chú thích là chung (website tự dịch)',
    localeDots:
      '● — đã có mô tả và SEO · ◐ — có mô tả, chưa có SEO · ○ — trống, sẽ được dịch khi lưu',
    preview: 'Như trên website',
    previewHint: 'Ẩn gợi ý, viền nét đứt, ô trống và bộ đếm CRM — bản hiển thị sạch để đối chiếu',
    featured: 'Nổi bật trên trang chủ',
    visibilityHint: 'Tắt — bản nháp, chỉ thấy trong CRM',
    featuredHint: 'Thẻ trên trang chủ; ảnh là ảnh có ★ «Trang chủ»',
    agentsHint: 'Không phụ thuộc vào việc xuất bản trên website',
    seoInfo:
      'Các văn bản này chỉ vào HTML cho bot (SSR). Người dùng thấy «{title}» trên tab trình duyệt',
    seoTitlePlaceholder: "Mua căn hộ tại {'{'}Tên{'}'} — giá từ chủ đầu tư",
    seoDescriptionPlaceholder: "{'{'}Tên{'}'} tại {'{'}Thành phố{'}'}: dự án là gì, giá, bàn giao",
    seoWillTranslate: 'sẽ được dịch khi lưu; nếu dịch không thành công — bot sẽ thấy văn bản gốc',
    seoBotsSee: 'bot sẽ thấy: {text}',
    seoOverLimit: 'sẽ bị cắt còn {max}',
    featuresHint:
      '«Dành cho người nước ngoài» và «Sổ hồng» nằm ở mục «Người nước ngoài» trên trang',
    foreigner: 'Dành cho người nước ngoài (kiểm tra nội bộ)',
    agentCommission: 'Hoa hồng đại lý, %',
    notPublished: 'không công khai',
    yes: 'Có',
    no: 'Không',
    commission: 'Hoa hồng VINPROP',
    commissionPercent: 'Mức, %',
    commissionSavedAt: 'Đã lưu {time}',
    commissionUnsaved: 'Chưa lưu',
    commissionEmptyHint: 'Trống — chưa đặt mức (không phải 0)',
    commissionBaseHint: 'Cơ sở thưởng giao dịch: giá chưa VAT × mức',
    commissionNoRight: 'Chỉ vai trò có quyền quản lý hoa hồng mới thay đổi được',
    commissionNotSet: 'chưa đặt',
    commissionLater: 'Hoa hồng VINPROP — sau khi tạo',
    commissionClear: 'Mức sẽ bị gỡ — giao dịch mới sẽ không có cơ sở thưởng.',
    salesStartNotSet: 'Chưa đặt ngày mở bán',
    salesStartEdit: 'Sửa → Căn hộ',
    salesStartHint: 'Cờ nằm ở tab Căn hộ và chỉ gỡ thủ công',
    salesStartLater: 'Mở bán — sau khi tạo',
  },
  save: {
    uploading: 'Đang tải lên {n} tệp — vui lòng đợi hoàn tất',
    invalid: 'Kiểm tra các trường được đánh dấu đỏ · {n} lỗi',
    errorsTitle: 'Chưa lưu: {n} lỗi',
    allFixed: 'Không còn lỗi — nhấn «Lưu»',
    toFirst: 'Đến lỗi đầu tiên',
    previewBlocked: 'Hãy sửa lỗi trước',
  },
  promos: {
    add: 'Thêm ưu đãi',
    example: 'Ví dụ: «Trả góp 0% trong 24 tháng»',
    counter: '{n} ký tự · tối thiểu {min}',
    removed: 'Đã xóa ưu đãi',
    remove: 'Xóa ưu đãi',
    hint: 'Ưu đãi không được dịch: website hiển thị nguyên văn ở mọi ngôn ngữ. Ưu đãi trống sẽ bị bỏ khi lưu',
  },
  tiles: {
    photos: '{n} ảnh',
    upload: 'Tải lên',
    slide: 'Trang {n}',
    add: 'Thêm',
    addHint: '≥800×1000 · 4:5',
    finishingEmpty: 'Ảnh hoàn thiện',
    constructionEmpty: 'Ảnh công trường',
    emptyHint: '4:5, từ 800×1000',
    pickFiles: 'Chọn tệp',
    replace: 'Thay',
    remove: 'Xóa',
    toStart: 'Lên đầu',
    toEnd: 'Xuống cuối',
    menu: 'Thao tác với ảnh',
    earliestFirst: 'Ảnh đầu tiên là sớm nhất',
    firstOldest: '№1 · cũ → mới',
    overlaySafe: '48 px dưới cùng của ô đầu tiên bị che bởi «Các lựa chọn hoàn thiện từ …»',
  },
  masterPlan: {
    empty: 'Tải lên mặt bằng',
    hint: 'Một ảnh, PNG/JPG, rộng từ 1600',
    pick: 'Chọn tệp',
    dropReplace: 'Thả để thay mặt bằng',
    removed: 'Đã xóa mặt bằng',
  },
  toggles: {
    counter: '{n}/{total}',
    selectAll: 'Chọn tất cả',
    clearAll: 'Bỏ chọn tất cả',
    foreignersLink: 'Cũng thêm một câu vào mục «Người nước ngoài»',
  },
  foreigners: {
    permitOff: 'Giấy phép bán cho người nước ngoài — chưa đánh dấu',
    availableHint:
      'Khác với «Người nước ngoài được mua» nội bộ trong bảng — mục đó không lên website',
    autoText: 'Văn bản được ghép tự động từ các thuộc tính',
    textLocale: 'Văn bản: {locale}',
  },
  header: {
    namePlaceholder: 'Tên dự án',
    highlights: 'Ưu điểm',
    crmLabel: 'trong CRM: {label}',
    rankTitle: 'Hạng dự án',
    rankEmpty: 'Chưa chỉ định',
    typeTitle: 'Loại dự án',
    typeEmpty: 'Chưa đặt',
    handoverTitle: 'Thời hạn bàn giao',
  },
  developer: {
    empty: 'Chọn chủ đầu tư',
    title: 'Chủ đầu tư',
    projects: '{n} dự án',
    loadError: 'Không tải được chủ đầu tư',
    textLocale: 'Văn bản: {locale}',
    separately: 'Lưu riêng',
    edit: 'Sửa chủ đầu tư',
    change: 'Đổi',
    nameLinkHint: 'Liên kết đến trang chủ đầu tư, đã tắt trong CRM',
    notSelected: 'Chưa chọn chủ đầu tư',
    logoHint: 'Logo được đổi trong thẻ chủ đầu tư · PNG 1:1 ≥320×320',
  },
  other: {
    auto: 'tự động',
    none: '{developer} chưa có dự án khác',
    later: 'Sẽ tự động hiển thị sau khi lưu',
    failed: 'Không tải được các dự án khác',
  },
  ribbon: {
    label: 'Khung ảnh bìa',
    keys: '←/→ — chuyển, Shift+mũi tên — sắp xếp, Delete — xóa, F — «Trang chủ», O — og:image, ⌘Z — hoàn tác xóa',
    count: 'Ảnh bìa · {n} ảnh',
    cardsFirst: '1 · thẻ danh mục',
    addHint: '≥1920×900',
    selected: 'Đã chọn {n}',
    makeFirst: 'Đặt lên đầu',
    remove: 'Xóa',
    removeFrame: 'Xóa khung',
    drag: 'Kéo',
    mainPage: 'Trang chủ website',
    mainPageHint: 'Khung chỉ vào băng chuyền trang chủ khi dự án «Nổi bật trên trang chủ»',
    og: 'og:image — ảnh cho mạng xã hội',
    ogElsewhere: 'og:image hiện lấy từ «{section}»',
  },
  crumbs: {
    cityPlaceholder: 'Thành phố',
    namePlaceholder: 'Tên dự án',
    url: 'URL: {url}',
    urlLater: 'URL sẽ xuất hiện sau khi lưu',
    urlWillChange: 'Địa chỉ sẽ được tính lại sau khi lưu',
    cityHint: 'Thành phố được sửa trong «Vị trí»',
  },
  hero: {
    dropTitle: 'Kéo ảnh bìa vào đây hoặc bấm «Tải lên»',
    dropHint: 'JPG/PNG, từ 1920×900',
    upload: 'Tải lên',
    dropRelease: 'Thả để thêm vào ảnh bìa',
    fromUnits: 'từ căn hộ',
    fromUnitsLater: 'sẽ lấy từ căn hộ',
    fromUnitsHint: 'Khoảng giá tính theo danh mục — sửa ở tab «Căn hộ»',
    siteButtonHint: 'Nút của website, không hoạt động trong CRM',
    safeZone: 'Vùng an toàn',
    viewports: { '1440': '1440', '1920': '1920', mobile: 'di động' },
    replace: 'Thay khung này',
    remove: 'Xóa',
    prev: 'Khung trước',
    next: 'Khung sau',
    frame: 'Khung {n}',
    zones: {
      price: 'Giá sẽ ở đây',
      promo: 'Nhãn ưu đãi ở đây',
      strip: 'Dải chủ đầu tư ở đây',
      wide: 'Bị cắt ở 1920',
      mobile: 'Bị cắt trên di động',
    },
  },
  images: {
    progress: '{done}/{total}',
    small: '{actual} — nhỏ hơn mức khuyến nghị {recommended}',
    portrait: 'Ảnh sẽ bị cắt về 4:5',
    retry: 'Thử lại',
    dismiss: 'Bỏ',
    removed: 'Đã xóa',
    restore: 'Hoàn tác',
    singleTaken: 'Mặt bằng chỉ có một ảnh: đã lấy ảnh đầu tiên',
    restToCommon: 'Thêm phần còn lại vào «Chung»',
    noPreview: 'og:image chưa được chọn — mạng xã hội sẽ lấy khung đầu tiên',
    errors: {
      format: 'Định dạng không phù hợp: cần JPG, PNG, GIF hoặc WebP',
      size: 'Tệp lớn hơn 32 MB',
      upload: 'Tệp chưa được tải lên',
    },
  },
  tray: {
    hint: 'Ảnh chưa phân loại sẽ không lên website',
    assignFailed: 'Không phân loại được ảnh: {message}',
    removeFailed: 'Không xóa được ảnh nhập: {message}',
    cleanupFailed: 'Không xóa được ảnh nhập: {message} — hãy thử lại',
    deleteAllTitle: 'Xóa {count} ảnh khỏi đám mây?',
    deleteAllDescription: 'Không thể hoàn tác: các tệp nhập sẽ bị xóa.',
    deleteAllAction: 'Xóa {count}',
    publishTitle: 'Xuất bản dự án',
    publishWarning: '{count} ảnh nhập sẽ bị xóa khỏi đám mây',
    publishAction: 'Xuất bản và xóa {count}',
  },
  head: {
    published: 'Đã xuất bản',
    filled: 'Đã điền {n}/{total}',
    changes: 'Thay đổi: {n}',
    errors: '{n} lỗi',
    create: 'Tạo dự án',
    saving: 'Đang lưu…',
    saveAndPublish: 'Lưu và xuất bản',
    saveAndUnpublish: 'Lưu và gỡ khỏi website',
  },
  anchors: {
    label: 'Các mục của trang',
    emptyHint: 'Trống — mục bị ẩn trên website',
  },
  leave: {
    title: 'Thay đổi chưa được lưu',
    stay: 'Ở lại',
    leave: 'Rời đi không lưu',
    changes: 'Dự án có {n} thay đổi chưa lưu',
    changesShort: 'Dự án có {n} thay đổi',
    commission: 'mức hoa hồng VINPROP chưa được lưu',
    commissionOnly: 'Mức hoa hồng VINPROP chưa được lưu',
    uploads: 'Đang tải lên {n} tệp',
    uploadsTail: 'chúng sẽ không được thêm vào dự án',
    question: 'Rời đi mà không lưu?',
  },
  noPermission: 'Bạn không có quyền chỉnh sửa dự án',
  load: {
    errorTitle: 'Không tải được dự án',
    retry: 'Thử lại',
    toList: 'Về danh sách dự án',
  },
  sections: {
    hero: 'Ảnh bìa',
    header: 'Tiêu đề',
    amenities: 'Tiện ích',
    masterPlan: 'Mặt bằng',
    apartments: 'Căn hộ',
    promos: 'Ưu đãi',
    about: 'Giới thiệu',
    location: 'Vị trí',
    finishing: 'Hoàn thiện',
    developer: 'Chủ đầu tư',
    construction: 'Tiến độ',
    documents: 'Giấy tờ',
    foreigners: 'Người nước ngoài',
    other: 'Dự án khác',
  },
  panelGroups: {
    publication: 'Xuất bản',
    seo: 'SEO',
    noPlace: 'Không hiển thị trên website',
    service: 'Nội bộ',
  },
  errors: {
    promoTooShort: 'Ưu đãi #{n} phải có ít nhất {min} ký tự',
    agentCommissionRange: 'Hoa hồng đại lý phải từ 0 đến 100',
    wrongLanguage: {
      projectDescription: 'Mô tả {locale} giống {language}: {words}',
      seoTitle: 'SEO Title {locale} giống {language}: {words}',
      seoDescription: 'SEO Description {locale} giống {language}: {words}',
    },
  },
}

export const complexCanvasMessages = {
  ru: { properties: { canvas: ruCanvas } },
  en: { properties: { canvas: enCanvas } },
  vn: { properties: { canvas: vnCanvas } },
}
